import { useContentfulInspectorMode } from '@contentful/live-preview/react'
import { BLOCKS } from '@contentful/rich-text-types'
import { FootnoteIndexContext } from '@contexts/footnote-index'
import { FootnotesContext } from '@contexts/footnotes'
import { PageContext } from '@contexts/page'
import { ContentType } from '@entries/content-types'
import ContentfulFootnoteRichText from '@entries/contentful-footnote-rich-text'
import { useIsClientSide } from '@hooks/use-is-client-side'
import { sup } from '@render-mark/sup'
import { paragraphCaptionLegacy } from '@render-node/paragraph-caption-legacy'
import { Entry } from '@resolvers/entry'
import RichText from '@resolvers/rich-text'
import { defaultRichTextFieldOptionsDeprecated } from '@resolvers/rich-text/default-rich-text-field-options-deprecated'
import { isString } from '@utils/utils'
import React, { type FC, useContext, useId } from 'react'
import replace from 'string-replace-to-array'

const FootnoteList: FC = () => {
  const { footnotes } = useContext(FootnotesContext)
  const hasFootnotes = Boolean(footnotes.length)
  const isClientSide = useIsClientSide()

  // TODO: remove legacy footnotes
  const page = useContext(PageContext)
  const inspectorProps = useContentfulInspectorMode({
    entryId: page?.contentful_id,
  })

  if (!isClientSide) {
    return null
  }

  return (
    (page?.footnote || hasFootnotes) && (
      <div className="section-content-layout px-default flex flex-col gap-4 py-10 group-[.is-dark]/theme:opacity-70">
        {footnotes.map((footnote, index) => (
          <FootnoteIndexContext.Provider key={footnote.id} value={index}>
            <Entry
              key={footnote.id}
              content={footnote}
              mapping={{
                [ContentType.ContentfulFootnote]: ContentfulFootnoteRichText,
              }}
            />
          </FootnoteIndexContext.Provider>
        ))}
        {page?.footnote && (
          <RichText
            {...inspectorProps({
              fieldId: 'footnote',
            })}
            content={page.footnote}
            options={{
              ...defaultRichTextFieldOptionsDeprecated,
              renderNode: {
                ...defaultRichTextFieldOptionsDeprecated.renderNode,
                [BLOCKS.PARAGRAPH]: paragraphCaptionLegacy,
              },
              renderText: (text: string) =>
                replace(text, /\^([()0-9*]*)*\^/g, (text, offset) =>
                  sup(offset)
                ).map((text) => {
                  if (isString(text)) {
                    return replace(text, /\n/g, () => {
                      const id = useId()
                      return <br key={id} />
                    })
                  }

                  return text
                }),
            }}
          />
        )}
      </div>
    )
  )
}

export default FootnoteList
